
export default {
    /**
     * スライドフェードインアニメーションを行います。
     * @param {string} selector 対象領域のセレクタ
     * @param {string} target 対象領域内のエレメント取得セレクタ
     */
    animate : function (selector, target) {
        //target = "p, div, h2, h3, input";
        var elements = document.querySelector(selector).querySelectorAll(target)
        
        var count = 0;
        elements.forEach(function(x){
            if(count % 2 == 0){
                x.style["transform"] = "translate(10px, 0px)";
            }else{
                x.style["transform"] = "translate(0px, 10px)";
            }
            x.style["opacity"] = '0';
            x.style["transition"] = 'none ease-out 200ms ' + (count*100) + "ms";
            count++;
        })

        setTimeout(function(){
            elements.forEach(function(x){
                x.style["transition-property"] = 'transform, opacity'
                x.style["transform"] = '';
                x.style["opacity"] = '';
            })
        }, 50);
    },

    /**
     * 不可視のインラインフレームを利用してURLを開きます。
     * @param {string} href URL
     */
    launchUrlInFrame : function(href){
        let frm = document.getElementById("invisible-launch-frame")
        if(!frm){
            frm = document.createElement("iframe")
            frm.style["display"] = "none"
            frm.style["height"] = "500px"
            frm.id = "invisible-launch-frame"
            document.body.appendChild(frm)
        }
        frm.src = href
    },
    
    /**
     * 日時型を整形します。
     * @param {Date} d 日時
     * @param {string} format フォーマット指定子
     * @returns {string} フォーマット化された文字列
     */
    formatDate : function(d, format){
        var ret = dateFormatParts(d, format);
        if(ret != "") return ret;

        var splited = format.split(/[^yMHdms]+/);
        ret = format;
        for(var i=0; i<splited.length; i++){
            ret = ret.replace(splited[i], dateFormatParts(d, splited[i]));
        }
        return ret;
    
        function dateFormatParts(d, format){
            switch(format){
                case "yy": return("00" + d.getFullYear()).substr(-2);
                case "yyyy": return("0000" + d.getFullYear()).substr(-4);
                case "MM": return ("00" + (d.getMonth()+1)).substr(-2);
                case "dd": return ("00" + d.getDate()).substr(-2);
                case "HH": return ("00" + d.getHours()).substr(-2);
                case "mm": return ("00" + d.getMinutes()).substr(-2);
                case "ss": return ("00" + d.getSeconds()).substr(-2);
                case "M" : return ("" + (d.getMonth()+1));
                case "d" : return ("" + d.getDate());
                case "H" : return ("" + d.getHours());
                case "m" : return ("" + d.getMinutes());
                case "s" : return ("" + d.getSeconds());
                case "ddd" : 
                    return ["日", "月", "火", "水", "木", "金", "土"][d.getDay()];
                default : return "";
            }
        }
    },

    /**
     * 経過分値を整形します。
     * @param {number} min 00:00からの経過分
     * @returns {string} HH:mm形式の文字列
     */
    formatTime : function(min){
        if(min < 0){
            return this.formatTime(24*60 - min)
        }
        let h = Math.trunc(min / 60) % 24
        let m = min % 60
        
        let ret = `${("00"+h).substr(-2)}:${("00"+m).substr(-2)}`
        if(min >= 24 * 60){
            ret = "翌" + ret
        }
        return ret
    },

    /**
     * 指定日数を加算した新たな日時値を返します。
     * @param {Date} d 基準日時
     * @param {number} value 加算日数
     */
    addDate(d, value){
        let ret = new Date(d.getTime())
        ret.setDate(ret.getDate() + value)
        return ret
    },

    /**
     * Base64URL形式に変換します。
     * @param {string} str 文字列
     * @returns {string} base64形式文字列
     */
    encodeBase64url : function(str){
        str = window.btoa(str)
        str = str.replace('+', '-')
        str = str.replace('/', '_')
        while(str.length % 4 != 0){
            str += "="
        }
        return str
    },
    
    /**
     * 文字列内の全角数値を半角数値に変更します。
     * @param {string} str 対象文字列
     * @returns {string} 変換結果
     */
    toHalfNum(str){
        str = `${str}`
        let ret = ""
        for(let i=0; i<str.length; i++){
            let c = str.charAt(i)
            if('０' <= c && c <= '９'){
                ret += 0 + (c.charCodeAt() - '０'.charCodeAt())
            }else{
                ret += c
            }
        }
        return ret
    },

    /**
     * HSL値をRGB値に変更します。
     * @param {number} h 
     * @param {number} s 
     * @param {number} l 
     */
    hslToRgb(h, s, l){
        let max,min
        let r,g,b

        if(l <= 49){
            max = 2.55 * (l + l * (s / 100));
            min = 2.55 * (l - l * (s / 100));
        }else{
            max = 2.55 * (l + (100 - l) * (s / 100));
            min = 2.55 * (l - (100 - l) * (s / 100)); 
        }  
        
        if (h < 60){
            r = max;
            g = min + (max - min) * (h / 60) ;
            b = min;
        }else if (h >= 60 &&  h < 120){
            r = min + (max - min) * ((120 - h) / 60);
            g = max ;
            b = min;
        }else if (h >= 120 &&  h < 180){
            r = min;
            g = max ;
            b = min + (max - min) * ((h - 120) / 60);
        }else if (h >= 180 &&  h < 240){
            r = min;
            g = min + (max - min) * ((240 - h) / 60);
            b = max;
        }else if (h >= 240 &&  h < 300){
            r = min + (max - min) * ((h - 240) / 60);
            g = min;
            b = max;
        }else if (h >= 300 &&  h < 360){
            r = max;
            g = min;
            b = min + (max - min) * ((360 - h) / 60);
        }
        return { r: Math.round(r), g: Math.round(g), b: Math.round(b) }
    },

    compare(a, b){
        if(a == undefined) a = null
        if(b == undefined) b = null
        if(a == b) return 0
        if(a == null) return -1
        if(b == null) return 1
        if(a > b) return 1
        if(a < b) return -1
    },

    /**
     * 当日を取得します。
     * @returns {Date} 時分以下は0の日時型
     */
    getToday(){
        let now = new Date()
        return new Date(now.getFullYear(), now.getMonth(), now.getDate())
    },
    
    /**
     * コンポーネントで未入力として扱う日時を取得します。
     * @returns {Date}
     */
    getNullDate(){
        return new Date(1800, 0, 1)
    },

    /**
     * 日時型から時分以下を0クリアしたオブジェクトを生成します。
     * @param {Date} d 
     * @returns {Date}
     */
    getDateValue(d){
        return new Date(d.getFullYear(), d.getMonth(), d.getDate())
    },

    /**
     * 1970/1/1 09:00:00からの経過秒を取得します。
     * これは一部において正確なEpoch秒(getTime()/1000)とは異なります。
     * @param {Date} d 
     */
    toEpochSec(d){
        let zero = Date.UTC(1970, 0, 1, 9, 0, 0, 0)

        let x = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours()
            , d.getMinutes(), d.getSeconds(), d.getMilliseconds())

        return (x - zero) / 1000
    },
    /**
     * 1970/1/1 09:00:00からの経過秒から日時を取得します。
     * @param {Number} t
     * @returns {Date}
     */
    fromEpocSec(t){
        let d = new Date(1970, 0, 1, 9, 0, 0, 0)
        d.setSeconds(t)
        return d
    },

    /**
     * 配列から重複分を除いた配列を返します。
     * @param {any[]} ary 対象配列
     * @returns {any[]} 重複を除いた配列
     */
    distinct(ary){
        let set = new Set()
        let ret = []
        ary.forEach(x=>{
            if(!set.has(x)){
                set.add(x)
                ret.push(x)
            }
        })
        return ret
    },

    /**
     * URLからクエリパラメータを取得します。
     * @returns {object} 
     */
    getUrlQuerys(){
        if(!location.search.startsWith("?")) return {}

        let ret = {}
        location.search.substring(1).split("&").forEach(x=>{
            let sp = x.split("=")
            ret[sp[0]] = sp[1]
        })
        return ret
    },
    
    scroll(value){
        var start = document.scrollingElement.scrollTop
        var val = start
        var plus = start <= value

        var key = setInterval(function() {
            var span = (value - val) / 10
            if(plus) span = Math.max(span, 1.0)
            else span = Math.min(span, -1.0)
            
            val += span
            if((plus && val >= value) || (!plus && val <= value)){
                val = value
                clearInterval(key)
            }
            document.scrollingElement.scrollTop = val
        }, 10);
    },

    /**
     * メールアドレスの形式をチェックします。
     */
    testMailAddress(str){
        return /^[^@,\s]+@[^@,\s]+$/.test(str.trim())
    }
}